export default __webpack_public_path__ + "static/media/back.8cb750d6.svg";